import React from 'react';
import ButtonComponent from "../../components/UI/ButtonComponent/ButtonComponent";
import {  Form } from "react-bootstrap";
import "../../containers/ControlMeasures/ControlMeasures.css";
import DatePickerComponent from "../../components/UI/DatePicker/DatepickerComponent";
import ModalComponent from "../../components/UI/Modal/Modal";

const unosDatumaPravomocnosti = props => {

  
return (
<>

<ModalComponent
          size="m"
          show={props.modalDat}
          onHide={props.hideModalDat}
          title={props.modalTitle}
        >
          <div className="row justify-content-center" key={"form"}>
            <div className="align-self-center">
              <Form onSubmit={props.submitHandlerDat}>
               
              <div className="datepicker-modal" style = {{ marginBottom:"20px"}}>
                 <DatePickerComponent
                  required
                  errorBorderColor={
                    props.error && !props.formData.datPravomocnosti && "red"
                  }
                  id="datPravomocnosti"
                  handleDayClick={props.datePickerHandler}
                  controlLabel={"Datum pravomoćnosti"}
                  //selectedDays={props.formData.datPravomocnosti}
                  index={{ id: "datPravomocnosti" }}
                  width={"100%"}
                 // value={props.formData.datPravomocnosti}
                  />
              </div>

                <div className="row" key={"button"}>
                  <div className="col-md-6">
                    <ButtonComponent
                      type="submit"
                      block={true}
                      variant="primary"
                      onClick={props.hideModalDat}
                    >
                      Spremi
                    </ButtonComponent>
                  </div>
                  <div className="col-md-6">
                    <ButtonComponent
                      onClick={props.hideModalDat}
                      block={true}
                      variant="danger"
                      style={{marginRight:"7px"}}
                    
                    >
                    Odustani 
                    </ButtonComponent>
                  </div>
                </div>
           
              </Form>
            </div>
          </div>
        </ModalComponent>
</>
)};

export default unosDatumaPravomocnosti;